import { render } from "./CreateReservation.vue?vue&type=template&id=03022495&scoped=true"
import script from "./CreateReservation.vue?vue&type=script&lang=js"
export * from "./CreateReservation.vue?vue&type=script&lang=js"

import "./CreateReservation.vue?vue&type=style&index=0&id=03022495&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03022495"]])

export default __exports__